import { Component, OnInit, Input } from '@angular/core';
import { User } from 'firebase';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.css']
})
export class ContactComponent implements OnInit {
  @Input() uid : string;
  user : User;
  constructor(
    private userService: UserService
  ) { }

  ngOnInit() {
    this.userService.getUserById(this.uid).valueChanges().subscribe((data: User)=>{
      this.user = data;
    });
  }

}
